const initializeFloatingCartTriggers = () => {
  for (const trigger of document.querySelectorAll('[data-floating-cart-trigger]')) {
    if (!(trigger instanceof HTMLButtonElement) || trigger.dataset.floatingCartBound === 'true') continue;

    trigger.dataset.floatingCartBound = 'true';
    trigger.addEventListener('click', () => {
      const cartDrawer = document.querySelector('cart-drawer-component');

      if (typeof cartDrawer?.open === 'function') {
        cartDrawer.open();
        return;
      }

      if (typeof cartDrawer?.showDialog === 'function') {
        cartDrawer.showDialog();
        return;
      }

      cartDrawer?.querySelector('dialog')?.showModal();
    });
  }
};

initializeFloatingCartTriggers();
document.addEventListener('shopify:section:load', initializeFloatingCartTriggers);
